/**
 * `setCourseTo(stationId)` (spec §2.1, card C0): Set course through the existing route plotting. A station in
 * another system plots the knowledge-aware route there (`plotRoute`, R9's `planKnownRoute`); one in this system sets
 * it as the cruise target (`setNavTarget`), as the story lead link does (`story-link/ui.ts setLeadTarget`).
 */
import type { ReachCommandResult } from '../../../reach/types'
import type { CoursePort, StationDirectory } from './types'

export function setCourseTo(port: CoursePort, dir: StationDirectory, stationId: string): ReachCommandResult {
  const st = dir.stations.find((s) => s.id === stationId)
  if (st === undefined) return { ok: false, error: 'invalid', message: `No known station ${stationId}` }
  if (st.systemId === dir.hereSystemId) return port.command({ kind: 'setNavTarget', target: { kind: 'station', id: st.id } })
  return port.command({ kind: 'plotRoute', toSystemId: st.systemId, avoidHostile: false })
}
